import { render, staticRenderFns } from "./ReferencesView.vue?vue&type=template&id=18ae54de&scoped=true&"
import script from "./ReferencesView.vue?vue&type=script&lang=js&"
export * from "./ReferencesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae54de",
  null
  
)

export default component.exports